import { each, mix } from '@antv/util';
// è·åå¤ä¸ªç¶æéçåå¹¶å¼
export function getStatesStyle(item, elementName, stateStyles) {
    var styleName = elementName + "Style"; // activeStyle
    var styles = null;
    each(stateStyles, function (v, state) {
        if (item[state] && v[styleName]) {
            if (!styles) {
                styles = {};
            }
            mix(styles, v[styleName]); // åå¹¶æ ·å¼
        }
    });
    return styles;
}
//# sourceMappingURL=state.js.map